module.exports = __webpack_public_path__ + "img/down-arrow.b8c8a84c.svg";